import React from 'react';
import { FiAlertCircle, FiMail } from 'react-icons/fi';
import type { ContactEmailsState } from './useContactEmails';
import './emailConversation.css';

type Props = Pick<ContactEmailsState, 'emails' | 'error' | 'forbidden' | 'hasMore' | 'total' | 'canLoadMore' | 'loadingMore' | 'loadMore' | 'reload'>;

/**
 * Aviso da linha do tempo de e-mail na conversa: erro ao carregar (em vez de parecer vazia) e, quando o cliente tem mais
 * e-mails que os carregados, "Mostrando os N mais recentes" com o botão para carregar os anteriores.
 * Nada aparece sem e-mail no módulo (403) ou quando todos os e-mails já estão na tela.
 */
export const EmailHistoryNotice: React.FC<Props> = ({ emails, error, forbidden, hasMore, total, canLoadMore, loadingMore, loadMore, reload }) => {
  if (forbidden) return null;
  if (error) {
    return (
      <div className="email-history-notice email-history-error" role="alert">
        <FiAlertCircle aria-hidden="true" /> {error}
        <button type="button" className="email-btn email-btn-ghost email-history-btn" onClick={() => void reload()}>
          Tentar de novo
        </button>
      </div>
    );
  }
  if (!hasMore || emails.length === 0) return null;
  const shown = emails.length;
  return (
    <div className="email-history-notice" role="status">
      <FiMail aria-hidden="true" />
      {' '}
      {`Mostrando ${shown === 1 ? 'o e-mail mais recente' : `os ${shown} e-mails mais recentes`}${total > shown ? ` de ${total}` : ''}.`}
      {canLoadMore && (
        <button
          type="button"
          className="email-btn email-btn-ghost email-history-btn"
          onClick={() => void loadMore()}
          disabled={loadingMore}
        >
          {loadingMore ? 'Carregando…' : 'Carregar e-mails anteriores'}
        </button>
      )}
    </div>
  );
};
